import { GET, POST } from './Clients';

const FRONTEND_APIS_PREFIX = '/marketplace/frontend-apis/v2';

export async function getMyChainChildren({ ctx } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/me/chain/children`,
  });
}

export async function getConcurrentPresence({ ctx } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/me/concurrent-presence`,
  });
}

/**
 * @param {{ childAccountId: number, clientId?: string, targetAppId?: number, ctx?: any, token?: string }} [options]
 */
export async function switchChildAccount({ childAccountId, clientId, targetAppId, ctx, token } = {}) {
  const body = { childAccountId };
  if (clientId) {
    body.clientId = clientId;
  }
  if (targetAppId) {
    body.targetAppId = targetAppId;
  }

  return POST({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/me/chain/switch-account`,
    body,
    ...(token ? { ssoToken: token } : {}),
  });
}

const ChainClient = {
  getMyChainChildren,
  getConcurrentPresence,
  switchChildAccount,
};

export default ChainClient;
